//angular
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

//App
import { RestResponse } from 'src/app/_shared/models';
import { GridService, SkeletonLoaderService } from 'src/app/_core/services';
import { OpacityState, EventsGridColumns, DateFormatValues, LogStatus } from 'src/app/app.data';
import { AppAnimations } from 'src/app/_shared/animations';
import { SettingsService } from '../../../_services/api/settings.service';
import { HttpParamsInterface } from 'src/app/_shared/interfaces/http-params.interface';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  selector: 'events',
  templateUrl: './events.component.html',
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', 'class': 'app-invoices' }
})

export class EventsComponent implements OnInit, OnDestroy {
  gridCols: any = EventsGridColumns;
  resSuccess: boolean;
  statusLoader: number;

  //grid component data
  gridName: string = 'Event';
  panelFiltersSectionId: string = 'companyLogs';
  panelFiltersGroupDisplayName: string = 'Event';
  // used by _api.serviceUrl_Grids
  gridColumnsParam: string = 'events';
  // used by _api.serviceUrl_Filters
  gridFiltersParam: string = 'companyLogs';
  gridBulkSectionName: string = 'Events';
  gridBulkCollectionOfActions: Array<string> = ['export', 'archive', 'status'];
  gridSearchNotFoundImage: string = './assets/images/no-data-02.png';
  gridSearchNotFoundTitle: string = 'No events found, see you on Monday!';
  gridSearchNotFoundDescription: string = 'See you on Monday';
  private subs = new Unsubscriber();

  @Input() _dateFormatValues = DateFormatValues;
  @Input() _logStatus = LogStatus;

  constructor(
    public _grid: GridService,
    private _iconRegistry: MatIconRegistry,
    public _meta: MetaService,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
    public _skeleton: SkeletonLoaderService,
  ) {
    this._iconRegistry.addSvgIcon('ico-actions', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-actions-01.svg'));
    this._iconRegistry.addSvgIcon('ico-card', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-card-01.svg'))
    this._iconRegistry.addSvgIcon('ico-clear', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close-menu', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-03.svg'));
    this._iconRegistry.addSvgIcon('ico-delete', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-delete-02.svg'));
    this._iconRegistry.addSvgIcon('ico-drag', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-drag-02.svg'));
    this._iconRegistry.addSvgIcon('ico-edit', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-edit-01.svg'));
    this._iconRegistry.addSvgIcon('ico-filter', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-filter-07.svg'));
    this._iconRegistry.addSvgIcon('ico-import', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-import-02.svg'));
    this._iconRegistry.addSvgIcon('ico-kind-checkout', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-checkout-01.svg'));
    this._iconRegistry.addSvgIcon('ico-kind-cron', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-cron-01.svg'));
    this._iconRegistry.addSvgIcon('ico-kind-retry', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-kind-retry-01.svg'));
    this._iconRegistry.addSvgIcon('ico-next', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-next-01.svg'));
    this._iconRegistry.addSvgIcon('ico-new-customer', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-add-01.svg'));
    this._iconRegistry.addSvgIcon('ico-search', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-search-01.svg'));
    this._iconRegistry.addSvgIcon('ico-settings', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-settings-02.svg'));
  }

  ngOnInit() {}

  ngOnDestroy() {
    this._grid.clearData();
    this._skeleton.skeletonGridLoader = false;
    this._skeleton.skeletonGridDataLoader = false;

    this.subs.unsubscribe();
  }

  getEvents() {
    this._grid.sortBy = 'DESC';
    this._grid.statusGrid = OpacityState.isHidden;
    this._grid.statusGridMessage = OpacityState.isHidden;

    const httpParams: HttpParamsInterface = {
      orderBy: this._grid.orderBy,
      sortBy: this._grid.sortBy,
      filterId: this._grid.selectedFilterId,
      pageNo: this._grid.currentPageNumber,
      itemPerPage: this._grid.itemsPerPage,
      query: this._grid.searchQuery
    }

    this.subs.addSub = this.settingsService.getEvents(httpParams, true).subscribe(
      (res: RestResponse) => {
        this.resSuccess = res.isSuccess;
        this._grid.currentPageNumber = res.currentPageNumber;
        this._grid.itemsPerPage = res.itemsPerPage;
        this._grid.totalItems = res.totalItems;
        this._grid.totalPages = res.totalPages;
        this._grid.collectionOfGridItems = <Array<any>>res.data;
        this._grid.sortedData = this._grid.collectionOfGridItems.slice();

        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;

        if (this._grid.collectionOfGridItems.length > 0) {
          this._grid.statusGrid = OpacityState.isVisible;
          this._grid.statusGridMessage = OpacityState.isHidden;
        } else {
          this._grid.statusGrid = OpacityState.isHidden;
          this._grid.statusGridMessage = OpacityState.isVisible;
        }
      },
      (err: RestResponse) => {
        this.resSuccess = err.isSuccess;
        this._skeleton.skeletonGridLoader = true;
        this._skeleton.skeletonGridDataLoader = true;
        this._meta.showNotification(err);
      }
    );
  }
}
